import { get, post, put } from "./apiClient";

export default {
  async getByFacilityId(facilityId) {
    return await get(`facility/${encodeURIComponent(facilityId)}/licenses`);
  },

  async getByCustomerId(customerId) {
    return await get(`customer/${encodeURIComponent(customerId)}/licenses`);
  },

  async create(facilityId, license) {
    return await post(
      `facility/${encodeURIComponent(facilityId)}/licenses`,
      license
    );
  },

  async edit(license) {
    return await put(`licenses/${encodeURIComponent(license.id)}`, license);
  }
};
